import { tv } from "../../variants/tv.js";
const TabsEmphasisVariants = {
    regular: {
        tab: 'hover:bg-primary-3 active:bg-primary-4 text-primary-13 data-disabled:hover:bg-transparent data-disabled:active:bg-transparent data-disabled:text-primary-6 focus-visible:inset-ring-actionPrimary-12',
        indicator: 'bg-primary-8',
        panel: 'focus-visible:border-primary-8'
    },
    medium: {
        tab: 'hover:bg-primary-3 active:bg-primary-4 text-primary-13 data-disabled:hover:bg-transparent data-disabled:active:bg-transparent data-disabled:text-primary-6 focus-visible:inset-ring-actionPrimary-12',
        indicator: 'bg-primary-8',
        panel: 'focus-visible:border-primary-8'
    }
};
const tabsEmphases = Object.keys(TabsEmphasisVariants);
const tabsVariants = tv({
    slots: {
        root: 'relative overflow-x-hidden',
        list: 'relative isolate flex w-full gap-1 overflow-x-auto pb-2',
        tab: 'focus-visible:inset-ring-2 focus-visible:inset-ring-offset-2 data-disabled:cursor-not-allowed group flex cursor-pointer select-none items-center justify-center rounded-lg px-3 py-2 focus-visible:outline-none',
        indicator: '-z-1 absolute bottom-0 left-0 h-1 w-[var(--active-tab-width)] -translate-y-1/2 translate-x-[var(--active-tab-left)] rounded-sm transition duration-200 ease-in-out',
        panel: 'focus-visible:border focus-visible:outline-none',
        tabLabelContent: 'flex flex-col items-start justify-center text-left',
        icon: ''
    },
    variants: {
        emphasis: TabsEmphasisVariants,
        stacked: {
            true: {
                root: '@container w-full',
                tab: '@max-3xl:flex-col @max-3xl:px-2 @min-3xl:flex-row gap-0',
                icon: '@min-3xl:mr-2 size-8'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular',
        stacked: false
    }
});
export { TabsEmphasisVariants, tabsEmphases, tabsVariants };
